import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ControlledSidebar',
  props: {
    open: { type: Boolean },
    dimmer: { type: Boolean, default: false },
    expandable: { type: Boolean, default: false },
    width: { default: '33%' }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { open: boolean, dimmer: boolean, expandable: boolean, width: string };





const expanded = ref(false);

watch(
  () => props.open,
  (isOpenNow: boolean, wasOpen: boolean) => {
    if (wasOpen && !isOpenNow) {
      expanded.value = false;
    }
  },
);

return { __sfc: true,props, emit, expanded }
}

})